import React from "react";
import { Container, Button, Typography, Grid2 } from "@mui/material";
import LoginImage from '../assets/LoginImage.svg'
import whcLogo from '../assets/whcLogo.svg';
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { getLogin, checkSession } from "../slice/AuthSlice";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import { sessionEndedReason, startFresh } from "../utils/idleSession";

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f6f8fa;
  height: 98vh;
`;

const StyledLoginDiv = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledSignInLogoImg = styled.div`
  width: 50%;
`;

const StyledSignInGrid = styled.div`
  background-color: white;
`;


const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setisLoading] = React.useState(false);
  const [endedReason] = React.useState(() => sessionEndedReason());
  const handleLogin = async () => {
    setisLoading(true);
    startFresh();
    dispatch(checkSession()).then((response) => {
      if (response.payload.status === 401) {
        // Need to check for refresh API
        // error message should need to display
        dispatch(getLogin());
        setisLoading(false);
      } else if (response.payload.status === 200) {
        navigate('/home', { replace: true });
        setisLoading(false);
      } else if (response.error.message === "Rejected") {
        setisLoading(false);
        // Handle the error case
        console.error("Error occurred during login:", response.error.message);
      }
    });
  };

  return (
    <StyledDiv>
      {isLoading && <Loader /> }
      <Container sx={{ maxWidth: 'none !important', margin: 'auto 10%' }}>
        <StyledSignInGrid>
          <Grid2 container>
            <StyledSignInLogoImg>
              <Grid2 item >
                <img src={LoginImage} alt="Login pic" width="100%" />
              </Grid2>
            </StyledSignInLogoImg>
            <StyledLoginDiv>
              <Grid2 item sx={{ width: '60%' }}>
                <Typography variant="h5" align="center" gutterBottom>
                  <img src={whcLogo} alt="whc Logo" />
                </Typography>
                <Typography variant="h5" align="center" sx={{ marginTop: 5, fontWeight: "600" }} gutterBottom>
                  Sign in to DMS
                </Typography>
                {endedReason && endedReason !== "signed_out" && (
                  <Typography align="center" gutterBottom sx={{ color: "#1F2937", fontSize: "14px", fontWeight: 500 }}>
                    {endedReason === "idle"
                      ? "You were signed out after an hour without activity."
                      : "Your sign-in has ended."}
                  </Typography>
                )}
                <Typography align="center" gutterBottom sx={{ color: "#48566B", fontSize: "14px" }}>
                  Sign in via salesforce to continue.
                </Typography>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#0C53BB", marginTop: 5, fontWeight: 500, textTransform: "none", width: "100%", borderRadius: '8px' }}
                  onClick={handleLogin}
                >
                  Sign in via Salesforce
                </Button>

              </Grid2>
            </StyledLoginDiv>
          </Grid2>
        </StyledSignInGrid>
      </Container>
    </StyledDiv>
  );
};

export default LoginPage;
